export default {"src":"/org/_next/static/media/app-store.c992173a.svg","height":33,"width":28,"blurWidth":0,"blurHeight":0};